
import { SaleLayoutTextSettings } from "@/utils/sale-layouts/text-settings";
import Vue from "vue";
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";

export default Vue.extend({
	data() {
		return {
			selectedLanguage: ""
		};
	},
	props: {
		settings: Object as () => SaleLayoutTextSettings
	},
	components: {
		AppCustomLanguageSelect
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
